import { MaterialIcons } from "@expo/vector-icons";
import { Center, Flex, IconButton } from "native-base";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "react-native";

import { Scale } from "../constants";
import { formatUserForDisplay } from "../helpers/generalHelpers";
import type { User } from "../services/backendTypes";

interface ViewAsUserHeaderProps {
  viewAsUser: User | null;
  onPressBack: () => void;
}

const ViewAsUserHeader = ({ viewAsUser, onPressBack }: ViewAsUserHeaderProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!viewAsUser) return null;

  const viewAsUserBackButtonIcon = {
    as: MaterialIcons,
    name: "arrow-back",
    color: "white",
  };

  return (
    <Flex flexDirection={"row"} alignItems={"center"} bgColor={"#9C9BDF"}>
      <Flex flexDirection={"row"} justifyContent="flex-start" alignItems={"center"}>
        <IconButton
          size={"md"}
          _icon={viewAsUserBackButtonIcon}
          testID={"diaryViewScreen-viewAsUser-back-button"}
          onPress={onPressBack}
        />

        <Flex ml={Scale(16)}>
          <Center>
            <Text testID={"diaryViewScreen-viewAsUser-banner"} style={{ color: "white", fontWeight: "bold" }}>
              {t("planner.view_as_user_banner_title", {
                username: formatUserForDisplay(viewAsUser),
              })}
            </Text>
          </Center>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ViewAsUserHeader;
